import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useApp } from '@pixi/react';
import { useEffect } from 'react';
import { useInstanceId } from '../../context/instance/instanceContext';
/**
 * Sets the `__PIXI_APP__` property to enable inspection via PixiJS Devtools.
 * See https://github.com/bfanger/pixi-inspector
 */
export const PixiDevToolsWrapper = ({ children }) => {
    const pixiApp = useApp();
    const instanceId = useInstanceId();
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const anyGlobalThis = globalThis;
        if (instanceId === 0 && pixiApp) {
            anyGlobalThis.__PIXI_APP__ = pixiApp;
        }
        return () => {
            if (instanceId === 0) {
                delete anyGlobalThis.__PIXI_APP__;
            }
        };
    }, [pixiApp, instanceId]);
    return _jsx(_Fragment, { children: children });
};
